var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1865 2.91748V5.57581C11.1865 5.93583 11.3299 6.2818 11.5857 6.53684C11.8421 6.79215 12.1893 6.93543 12.5512 6.93529H15.6006",
    stroke: "#0B54A0",
    strokeWidth: 1.1828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6693 7.21623V13.5501C15.6546 13.9644 15.5581 14.3717 15.3853 14.7485C15.2125 15.1253 14.9668 15.4642 14.6624 15.7457C14.3578 16.0284 14.0004 16.2484 13.6108 16.393C13.2211 16.5376 12.8068 16.604 12.3914 16.5884H6.78055C6.36268 16.6075 5.94516 16.5439 5.5519 16.4014C5.15865 16.2588 4.79741 16.04 4.48888 15.7575C4.18156 15.4753 3.93337 15.1348 3.75875 14.7559C3.58413 14.3769 3.48655 13.9671 3.47168 13.5501V5.95508C3.48636 5.54078 3.58288 5.13349 3.75568 4.75667C3.92849 4.37985 4.17416 4.04096 4.47853 3.75951C4.78316 3.47677 5.14052 3.25681 5.53018 3.11221C5.91984 2.96761 6.33417 2.9012 6.7495 2.91677H10.9736C11.6184 2.91449 12.2408 3.15308 12.7189 3.58579L14.9071 5.59802C15.1406 5.79915 15.3291 6.04719 15.4604 6.32599C15.5918 6.6048 15.6629 6.90812 15.6693 7.21623Z",
    stroke: "#0B54A0",
    strokeWidth: 1.1828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57031 8.64404V13.6517",
    stroke: "#0B54A0",
    strokeWidth: 1.1828,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8666 10.7518L9.89652 8.78168C9.8539 8.73854 9.80313 8.70429 9.74717 8.68092C9.69121 8.65754 9.63116 8.64551 9.57052 8.64551C9.50987 8.64551 9.44983 8.65754 9.39386 8.68092C9.3379 8.70429 9.28714 8.73854 9.24451 8.78168L7.27441 10.7525",
    stroke: "#0B54A0",
    strokeWidth: 1.1828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileNameIcon);
export default __webpack_public_path__ + "static/media/FileNameIcon.d9d3a0f423de9c01251400d04772df46.svg";
export { ForwardRef as ReactComponent };